import HNSColors from "../../../../ui library/HNSColors";

import ActionButton from "./ActionButton";

export default function SaveButton({
  disabled,
  onClick,
  label,
  color,
  hoverColor,
}) {
  return (
    <ActionButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: !disabled
          ? (color ?? HNSColors.secondary[500])
          : HNSColors.neutrals[800],
        color: !disabled ? HNSColors.neutrals[900] : HNSColors.neutrals[500],
        "&:hover": {
          backgroundColor: hoverColor ?? HNSColors.secondary[600],
          color: HNSColors.neutrals[900],
        },
      }}
    >
      {label}
    </ActionButton>
  );
}
